/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContactType } from '@gh/builder-shared-data';
import { CELL_PRIMARY_CLASS } from '@gh/common-internal-shared';
import { EnumDictionary, getRouteInitData } from '@gh/common-shared';
import { LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { GridOptions } from 'ag-grid-community';
import { sortBy, toPairs } from 'lodash';
import { ContactListItem } from '../../resources/contact-list-item.model';

@Injectable()
export class ContactGridDefinition extends LayoutBasedGridDefinition {

  columnDefs = {
    name: {
      cellClass: ({ data }: { data: ContactListItem }) => data.active ? CELL_PRIMARY_CLASS : '',
    },
    contactTypes: {
      cellRenderer: ({ data }: { data: ContactListItem }) =>
        sortBy(
          // translate type
          toPairs(data.types).map(([type, active]) => [this.contactTypeDict.get(<ContactType>type), Number(active)]),
          // sort by translated type
          ([type]) => type)
        // style according to the status
          .map(([type, active]) => active ? type : `<span class='warn-color'>${type}</span>`)
          // merge all statuses into the string
          .join(', '),
    },
  };

  private contactTypeDict: EnumDictionary<ContactType>;

  constructor(route: ActivatedRoute) {
    super();

    const { contactTypes } = getRouteInitData(route);
    this.contactTypeDict = contactTypes;
  }

  buildGridOptions(): GridOptions {
    return {
      getRowNodeId: (data: ContactListItem) => data.id,
    };
  }
}
